import { AnimationMixer, LoopOnce } from 'three';

function setupModel(data) {
  const model = data.scene;

  // 播放动画
  const mixer = new AnimationMixer(model);
  let actions = [];
  if(data.animations && data.animations.length != 0) {
    data.animations.forEach(a => {
      actions.push(mixer.clipAction(a))
    });
  }
  actions.forEach(a => {
    a.play();
  })

  return { model, mixer };
}

export { setupModel };
